import ChangeLogAutoSuggest from '../../../app/employer/components/autoSuggest/ChangeLogAutoSuggest';
import withAutoSuggestFormik from './withAutoSuggestFormik';

export default withAutoSuggestFormik(ChangeLogAutoSuggest);
